"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductNavSection = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _styles = require("@material-ui/core/styles");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _List = _interopRequireDefault(require("../../../List"));

var _shapes = require("../../shapes");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ProductNavSection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductNavSection, _Component);

  var _super = _createSuper(ProductNavSection);

  function ProductNavSection() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductNavSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMenuToggle", function () {
      _this.props.onToggle();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickAway", function () {
      _this.props.onToggle(false);
    });
    return _this;
  }

  (0, _createClass2.default)(ProductNavSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          productNavSections = _this$props.productNavSections,
          classes = _this$props.classes,
          isOpen = _this$props.isOpen;

      if (productNavSections.length === 0) {
        return "";
      }

      var topItemIndex = productNavSections.findIndex(function (item) {
        return window.location.pathname.includes(item.href);
      });
      topItemIndex = topItemIndex > -1 ? topItemIndex : 0;
      var topItem = productNavSections[topItemIndex];
      var items = productNavSections.filter(function (item, index) {
        return index !== topItemIndex;
      }).map(function (item) {
        return {
          itemText: {
            primary: "".concat(item.title)
          },
          button: true,
          dense: false,
          onClick: item.onClick || item.onClickAction ? function () {
            item.onClick ? item.onClick() : item.onClickAction();

            _this2.handleClickAway();
          } : undefined,
          href: item.href ? item.onClick || item.onClickAction ? null : item.href : null,
          className: classes.listItem
        };
      });
      return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
        onClickAway: this.handleClickAway
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root)
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: id + "-subnavigation",
        onClick: items.length > 0 ? this.handleMenuToggle : undefined,
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.canBeClicked, items.length > 0))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.iconContainer, classes.container)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: classes.selected
      }, topItem.title), items.length > 0 && /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "icon",
        className: (0, _classnames.default)(classes.arrowContainer, (0, _defineProperty2.default)({}, classes.arrowContainerOpen, isOpen)),
        "aria-haspopup": "menu",
        title: isOpen ? "Hide product tools" : "Show product tools"
      }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)))), /*#__PURE__*/_react.default.createElement(_Slide.default, {
        direction: "down",
        in: isOpen,
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.menu
      }, /*#__PURE__*/_react.default.createElement(_List.default, {
        "aria-label": "products",
        id: "".concat(id, "-subnavigation-menu"),
        listItems: items,
        className: (0, _classnames.default)(classes.list)
      })))));
    }
  }]);
  return ProductNavSection;
}(_react.Component);

exports.ProductNavSection = ProductNavSection;
(0, _defineProperty2.default)(ProductNavSection, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to pass styles from Page component
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The list of items to show in the product nav section.
   */
  productNavSections: _shapes.ProductNavSections,

  /**
   * Whether or not the subproduct menu is open or not
   */
  isOpen: _propTypes.default.bool,

  /**
   * The callback to fire when toggling the component
   */
  onToggle: _propTypes.default.func.isRequired
});

var _default = (0, _styles.withStyles)(_styles2.styles)(ProductNavSection);

exports.default = _default;